var Causa = (function () {
    function Causa(instancia, cir_id, cir_desc, tex, concepto, nivel, monto, habil, observaciones, caratula, usaRenaper, fileId, partes, file, adj, firmador, expConexo, orgDestino, secDestino) {
        this.instancia = instancia;
        this.cir_id = cir_id;
        this.cir_desc = cir_desc;
        this.tex = tex;
        this.concepto = concepto;
        this.nivel = nivel;
        this.monto = monto;
        this.habil = habil;
        this.observaciones = observaciones;
        this.caratula = caratula;
        this.usaRenaper = usaRenaper;
        this.fileId = fileId;
        this.partes = partes;
        this.file = file;
        this.adj = adj;
        this.firmador = firmador;
        this.expConexo = expConexo;
        this.orgDestino = orgDestino;
        this.secDestino = secDestino;
    }
    return Causa;
}());
export { Causa };
var CausaMasivo = (function () {
    function CausaMasivo(instancia, cir_id, tex, dobleIniciacion, fila, fecha, concepto, caracter, monto, caratula, habil, tasa, actorTipoPer, actorTipoDoc, actorTipoDocNro, actorGenero, actorUsaRenaper, actorNomyApe, actorDir, actorPro1Vinculo, actorPro1NroDoc, actorPro2Vinculo, actorPro2NroDoc, demandadoTipoPer, demandadoTipoDoc, demandadoTipoDocNro, demandadoGenero, demandadoUsaRenaper, demandadoNomyApe, demandadoDir, demandadoPro1Vinculo, demandadoPro1NroDoc, demandadoPro2Vinculo, demandadoPro2NroDoc, otrosTipoPer, otrosTipoDoc, otrosTipoDocNro, otrosGenero, otrosUsaRenaper, otrosNomyApe, otrosDir, otrosPro1Vinculo, otrosPro1NroDoc, otrosPro2Vinculo, otrosPro2NroDoc, tieneConfig, ttr_descr, ttr_tipoIngreso, errorMaxCantFilas, errorMaxCantFilasDescr, orgDestino, secDestino) {
        this.instancia = instancia;
        this.cir_id = cir_id;
        this.tex = tex;
        this.dobleIniciacion = dobleIniciacion;
        this.fila = fila;
        this.fecha = fecha;
        this.concepto = concepto;
        this.caracter = caracter;
        this.monto = monto;
        this.caratula = caratula;
        this.habil = habil;
        this.tasa = tasa;
        this.actorTipoPer = actorTipoPer;
        this.actorTipoDoc = actorTipoDoc;
        this.actorTipoDocNro = actorTipoDocNro;
        this.actorGenero = actorGenero;
        this.actorUsaRenaper = actorUsaRenaper;
        this.actorNomyApe = actorNomyApe;
        this.actorDir = actorDir;
        this.actorPro1Vinculo = actorPro1Vinculo;
        this.actorPro1NroDoc = actorPro1NroDoc;
        this.actorPro2Vinculo = actorPro2Vinculo;
        this.actorPro2NroDoc = actorPro2NroDoc;
        this.demandadoTipoPer = demandadoTipoPer;
        this.demandadoTipoDoc = demandadoTipoDoc;
        this.demandadoTipoDocNro = demandadoTipoDocNro;
        this.demandadoGenero = demandadoGenero;
        this.demandadoUsaRenaper = demandadoUsaRenaper;
        this.demandadoNomyApe = demandadoNomyApe;
        this.demandadoDir = demandadoDir;
        this.demandadoPro1Vinculo = demandadoPro1Vinculo;
        this.demandadoPro1NroDoc = demandadoPro1NroDoc;
        this.demandadoPro2Vinculo = demandadoPro2Vinculo;
        this.demandadoPro2NroDoc = demandadoPro2NroDoc;
        this.otrosTipoPer = otrosTipoPer;
        this.otrosTipoDoc = otrosTipoDoc;
        this.otrosTipoDocNro = otrosTipoDocNro;
        this.otrosGenero = otrosGenero;
        this.otrosUsaRenaper = otrosUsaRenaper;
        this.otrosNomyApe = otrosNomyApe;
        this.otrosDir = otrosDir;
        this.otrosPro1Vinculo = otrosPro1Vinculo;
        this.otrosPro1NroDoc = otrosPro1NroDoc;
        this.otrosPro2Vinculo = otrosPro2Vinculo;
        this.otrosPro2NroDoc = otrosPro2NroDoc;
        this.tieneConfig = tieneConfig;
        this.ttr_descr = ttr_descr;
        this.ttr_tipoIngreso = ttr_tipoIngreso;
        this.errorMaxCantFilas = errorMaxCantFilas;
        this.errorMaxCantFilasDescr = errorMaxCantFilasDescr;
        this.orgDestino = orgDestino;
        this.secDestino = secDestino;
    }
    return CausaMasivo;
}());
export { CausaMasivo };
var SorteoMasivo = (function () {
    function SorteoMasivo(expsSorteados, filaError, cerrarDespachoError, resultado) {
        this.expsSorteados = expsSorteados;
        this.filaError = filaError;
        this.cerrarDespachoError = cerrarDespachoError;
        this.resultado = resultado;
    }
    return SorteoMasivo;
}());
export { SorteoMasivo };
//# sourceMappingURL=causa.js.map